const s="analytics-user-id",e="user_id";export{s as DEFAULT_GTM_ANALYTICS_USER_STORAGE_KEY,e as GTM_EVENT_USER_ID_PROP};
